import { ILoginResponse } from './interfaces/login-response.interface';

export class Login {
  token: string;
  additionalInformation: {
    hash: string;
    name: string;
    email: string;
    document: string;
    birthDate: string;
    phoneNumber: string;
    postalCode: string;
    state: string;
    city: string;
  };

  constructor(data: ILoginResponse) {
    this.token = data.token;
    this.additionalInformation = {
      hash: data.hash,
      name: data.name,
      email: data.email,
      document: data.document,
      birthDate: data.birthDate,
      phoneNumber: data.phoneNumber,
      postalCode: data.postalCode,
      state: data.state,
      city: data.city,
    };
  }
}
